var lib_core = require("lib-core");
//var $        = require('jquery');

var AbstractView = {
    addKeyBindings: function(){

        var self = this;

        this.turnDocumnetEventIntoSMEvent = function(docEvent, SMEvent){
            // Here we handle everything ourselves, overriding all the most bindings in the browser
            docEvent.preventDefault();
            docEvent.stopPropagation();

            var cEvent = new lib_core.GuiEvent(SMEvent)
                .fromJSEvent(docEvent);

            var code_prefix = "";
            if (cEvent.data('metaKey') || cEvent.data('ctrlKey')) {
                code_prefix += "C_";
            }
            if (cEvent.data('shiftKey')) {
                code_prefix += "S_";
            }

            var keyCode = code_prefix + lib_core.KeyCode.toString(cEvent.data('which'));
            var code = code_prefix + cEvent.data('which');

            cEvent
                .data( 'code', code )
                .data( 'keyCode', keyCode )
                .data( 'mouseCoord', self.mouseCoord );

            self.stateMachine.handle(cEvent);
        }

        this.isAllowedBrowserEvent = function(docEvent){
             if ( docEvent.metaKey == true) {
                var keyCode = lib_core.KeyCode.toString(docEvent.keyCode);
                if (['r', 'f', 'a'].indexOf(keyCode) != -1) return true;
            }

            // Allow developer tools ( ⌥ ⌘ I, ⌥ ⌘ U, ⌥ ⌘ J )
            if (docEvent.altKey == true && docEvent.metaKey == true) {
                var keyCode = lib_core.KeyCode.toString(docEvent.keyCode);
                if (['i', 'u', 'j'].indexOf(keyCode) != -1) return true;
            }

            return false;
        }

        $(document).unbind('keydown').bind('keydown', function (event) {
            // Allow some browser hotkeys:

            // Allow reload ( ⌘ R, ⌘ F )
            if(self.isAllowedBrowserEvent(event)) return;

            // Prevent key events on an input field to get send to the statemachine
            var d = event.srcElement || event.target;
            if (d.tagName.toUpperCase() === 'INPUT' || d.tagName.toUpperCase() === 'TEXTAREA' || d.tagName.toUpperCase() === 'SELECT') {
                return;
            }

            self.turnDocumnetEventIntoSMEvent(event, lib_core.GuiEvents.GUI_KEY_PRESSED);
        });

        $(document).unbind('keyup').bind('keyup', function (event) {
            // Prevent key events on an input field to get send to the statemachine
            var d = event.srcElement || event.target;
            if (d.tagName.toUpperCase() === 'INPUT' || d.tagName.toUpperCase() === 'TEXTAREA' || d.tagName.toUpperCase() === 'SELECT') {
                return;
            }

            self.turnDocumnetEventIntoSMEvent(event, lib_core.GuiEvents.GUI_KEY_RELEASED);
        });
    }
};

module.exports = AbstractView;
